import { render, staticRenderFns } from "./SelectedStatusClosedConfirm.vue?vue&type=template&id=37a1b170&scoped=true&"
import script from "./SelectedStatusClosedConfirm.vue?vue&type=script&lang=js&"
export * from "./SelectedStatusClosedConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SelectedStatusClosedConfirm.vue?vue&type=style&index=0&id=37a1b170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1b170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VRow})
